export const CLEAR = '@GLOBAL/TRACKER/CLEAR'
export const SET_COMPANY_PROPERTIES = '@GLOBAL/TRACKER/SET_COMPANY_PROPERTIES'
export const SET_CONTACT_PROPERTIES = '@GLOBAL/TRACKER/SET_CONTACT_PROPERTIES'
export const EVENT = '@GLOBAL/TRACKER/EVENT'
export const IDENTIFY_COMPANY = '@GLOBAL/TRACKER/IDENTIFY_COMPANY'
export const IDENTIFY_CONTACT = '@GLOBAL/TRACKER/IDENTIFY_CONTACT'
export const PAGE_VIEW = '@GLOBAL/TRACKER/PAGE_VIEW'
export const PAGE_UNLOAD = '@GLOBAL/TRACKER/PAGE_UNLOAD'
export const REFRESH_SESSION = '@GLOBAL/TRACKER/REFRESH_SESSION'
